import http from "@/utils/request"
import { ErrorCode, isAppError } from "@/utils/error"
import { ID, PaginationResult } from "@/types/common"

type ListParams = Record<string, unknown>

export function createCrudApi<TItem, TCreate, TUpdate>(basePath: string) {
  async function list(params?: ListParams): Promise<PaginationResult<TItem>> {
    const res = await http.get<PaginationResult<TItem>>(basePath, { params })
    return res.data
  }

  async function getById(id: ID): Promise<TItem | null> {
    try {
      const res = await http.get<TItem>(`${basePath}/${id}`)
      return res.data
    } catch (error) {
      if (isAppError(error) && error.code === ErrorCode.NOT_FOUND) {
        return null
      }
      throw error
    }
  }

  async function create(data: TCreate): Promise<void> {
    await http.post(basePath, data)
  }

  async function update(id: ID, data: TUpdate): Promise<void> {
    await http.put(`${basePath}/${id}`, data)
  }

  async function deleteByIds(ids: ID[]): Promise<void> {
    await http.post(`${basePath}/batch-delete`, { ids })
  }

  return {
    list,
    getById,
    create,
    update,
    delete: deleteByIds,
  }
}
